import { find } from 'lodash';
import { createSelector } from 'reselect';
export const getTags = (state) => { var _a; return (_a = state.tags) !== null && _a !== void 0 ? _a : []; };
export const getMostPopularTags = (state) => state.mostPopularTags;
export const getTagBySlug = createSelector([getTags, (_, tagSlug) => tagSlug], (tags, tagSlug) => find(tags, (tag) => tag.slug === tagSlug));
//# sourceMappingURL=tags-selectors.js.map